import { Heading } from '@abyss/web/ui/Heading';
import { Main } from '@src/app/Main/Main';
import { Link } from '@abyss/web/ui/Link';
import React from 'react';
import { RouteUrl } from '@src/common/util/routeUrl';

export const Page404NotFound = () => {
  return (
    <Main className="center-content" id="notFound404Page">
      <div style={{ textAlign: 'center' }} data-testid="404-not-found">
        <div style={{ marginTop: '4rem' }}>
          <Heading>404 Not Found</Heading>
        </div>

        <p style={{ marginTop: '2rem', marginBottom: '2rem' }}>
          The page you are looking for does not exist.
        </p>

        <p>
          <Link isStandardAnchor href={RouteUrl.home}>
            Click here to return home
          </Link>
        </p>
      </div>
    </Main>
  );
};
